import { create } from 'zustand';

interface FixedChatState {
  chatId: string | undefined;
  setChatId: (chatId: string | undefined) => void;
}

export const useFixedChatStore = create<FixedChatState>((set, get) => ({
  chatId: undefined,
  setChatId: (chatId) => set({ chatId }),
}));
